import DataItem from 'components/DataItem';
import { displayISODateTime } from 'shared/helpers/common';
import useWhiteLabelSettings from 'hooks/useWhiteLabelSettings';
import { DEFAULT_PRIMARY_COLOUR } from 'shared/constants/styleConstants';

export default function CarHiresItem({ carHire }) {
  const {
    vehicleDescription,
    pickUp,
    dropOff,
    operatorName,
    supplierReference,
    startDate,
    endDate,
    carGroup,
    supplierCode,
  } = carHire;
  const { whiteLabelSettings: { primaryColour } = {} } = useWhiteLabelSettings();
  const backgroundStyle = {
    backgroundColor: primaryColour || DEFAULT_PRIMARY_COLOUR,
  };

  return (
    <div className="pb-8 bg-white">
      <div style={backgroundStyle} className="mt-[40px] rounded-t-lg text-white text-xl font-bold">
        <div className="p-4 text-[24px] font-medium">
          <div>{`${supplierCode} ${carGroup} Car Hire`}</div>
        </div>
      </div>
      <div className="flex flex-wrap bg-white pt-2 pb-3 px-4 md:px-8">
        {vehicleDescription && <DataItem label="Vehicle Description" value={vehicleDescription} />}
        <DataItem label="Pick Up Point" value={pickUp} />
        <DataItem label="Drop Off Point" value={dropOff} />
        {operatorName && <DataItem label="Operator Name" value={operatorName} />}
        <DataItem label="Supplier" value={supplierCode} />
        {supplierReference && <DataItem label="Supplier Reference" value={supplierReference} />}
        <DataItem label="Car Group" value={carGroup} />
        <DataItem
          label="Pick Up Date"
          value={displayISODateTime(startDate)}
        />
        <DataItem
          label="Drop Off Date"
          value={displayISODateTime(endDate)}
        />
      </div>
    </div>
  );
}
